export default function ComparisonTable({
  headers,
  rows,
  title,
  subtitle,
  source = "hrms",
}) {
  return (
    <section className="py-10 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-8">
          <h2 className="text-[#10324F] text-xl sm:text-3xl font-bold uppercase">
            {title}
          </h2>
          <p className="text-[#10324F] text-sm sm:text-base mt-2">{subtitle}</p>
        </div>

        <div className="overflow-x-auto rounded-md">
          <table className="w-full border-collapse text-left border-2 border-white">
            {/* Dynamic Header */}
            <thead className="bg-[#10324F] text-white">
              <tr>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="px-2 py-3 text-sm sm:text-base font-medium text-center"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            {source === "payrollfeature" && (
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={` text-center
                    ${idx % 2 === 0 ? "bg-white" : "bg-[#f9fbfd]"}
                    backdrop-blur-[15px]
                    shadow-[-10px_-10px_20px_0_#D1DFEA33,-5px_-5px_10px_0_#D1DFEA4D_inset]
                  `}
                  >
                    {/* Feature column */}
                    <td className="px-4 py-4 text-[#10324F] font-medium">
                      {row.feature}
                    </td>

                    {/* WAGGEX SELFIE = Green */}
                    <td className="px-4 py-4 table-compare-list-item-text text-red-800 ">
                      {row.without}
                    </td>

                    {/* BIOMETRIC MACHINE = Red */}
                    <td className="px-4 py-4 table-compare-list-item-text text-green-800">
                      {row.with}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
            {source === "selfie" && (
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`
                    ${idx % 2 === 0 ? "bg-white" : "bg-[#f9fbfd]"}
                    backdrop-blur-[15px]
                    shadow-[-10px_-10px_20px_0_#D1DFEA33,-5px_-5px_10px_0_#D1DFEA4D_inset]
                  `}
                  >
                    {/* Feature column */}
                    <td className="px-4 py-4 text-[#10324F] font-medium">
                      {row.feature}
                    </td>

                    {/* WAGGEX SELFIE = Green */}
                    <td className="px-4 py-4 table-compare-list-item-text  text-green-800">
                      {row.with}
                    </td>

                    {/* BIOMETRIC MACHINE = Red */}
                    <td className="px-4 py-4 table-compare-list-item-text text-red-800">
                      {row.without}
                    </td>

                    {/* MANUAL REGISTER = Red */}
                    <td className="px-4 py-4 table-compare-list-item-text text-red-800 ">
                      {row.manual}
                    </td>
                    <td className="px-4 py-4 table-compare-list-item-text text-green-800 text-center">
                      {row.pf}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
            {/* Dynamic Rows */}
            {source !== "selfie" && source !== "payrollfeature" && (
              <tbody>
                {rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`
                    ${idx % 2 === 0 ? "bg-white" : "bg-[#f9fbfd]"}
                    backdrop-blur-[15px]
                    shadow-[-10px_-10px_20px_0_#D1DFEA33,-5px_-5px_10px_0_#D1DFEA4D_inset]
                  `}
                  >
                    {Object.values(row).map((value, i) => (
                      <td
                        key={i}
                        className={`px-4 py-3 compare-list-item-text  ${
                          i === 0
                            ? "font-medium text-gray-700"
                            : "text-[#10324F]"
                        }`}
                      >
                        {value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </section>
  );
}
